module.exports = __webpack_public_path__ + "static/media/Failure.aecc93fc.PNG";